// src/utils/categoryMapper.js
import { CATEGORIES_DATA } from '../constants/Categories';


export const findSubCategoryId = (categoryName, subCategoryName) => {
  // 1. Find the main category block
  const category = CATEGORIES_DATA.find(c => c.title === categoryName);
  if (!category) return null;

  // 2. Find the sub-category ID by matching the name
  // AI says "Maruti Suzuki" -> we find id "car_maruti"
  const sub = category.subCategories.find(s => 
    s.name.toLowerCase().includes(subCategoryName.toLowerCase()) ||
    subCategoryName.toLowerCase().includes(s.name.toLowerCase())
  );

  return {
    categoryId: category.id,
    subCategoryId: sub ? sub.id : `${category.id}s1` // Fallback to first subcat
  };
};

export const getCategoryBreadcrumbs = (catId, subCatId) => {
  const category = CATEGORIES_DATA.find(c => c.id === catId);
  if (!category) return "";
  
  const subCategory = category.subCategories?.find(s => s.id === subCatId);
  
  return {
    categoryTitle: category.title,
    subCategoryTitle: subCategory ? subCategory.name : ""
  };
};